import { createSelector } from "@reduxjs/toolkit";

const selectSelf = (state: any) => state.auth;
export const getToken = createSelector(selectSelf, (state) => state.token);

export const appUsernameSelector = createSelector(selectSelf, (state) => state.userData.username);
export const appUserDataSelector = createSelector(selectSelf, (state) => state.userData);
